import AbstractStorage from './AbstractStorage';
import {getSafeStorage} from './safeStorage';
import {jsonParse} from './utils';

const storage = () => getSafeStorage('sessionStorage');

class SessionStorage extends AbstractStorage {
  static get<T>(key: string): T | null {
    const data = storage().getItem(key);
    return jsonParse(data);
  }

  static set<T>(key: string, value: T): void {
    if (value) {
      storage().setItem(key, JSON.stringify(value));
    }
  }

  static update<T>(key: string, field: string, value: T): void {
    const data = SessionStorage.get<Record<string, T>>(key);

    if (data) {
      data[field] = value;
      SessionStorage.set(key, data);
    } else {
      SessionStorage.set(key, {[field]: value});
    }
  }

  static remove(key: string): void {
    storage().removeItem(key);
  }

  static clear(): void {
    storage().clear();
  }
}

export {SessionStorage};
